import React, { useState } from "react";

// Import attendance components
import ManualAttendance from "components/attendance/ManualAttendance";

// Import Attendance API Slices
import {
  useUpdateAttendanceSheetMutation,
  useMarkAttendancesMutation,
} from "state/slices/attendance/attendanceApiSlice";

// Importing toast utilities
import { showSuccessToast } from "utils/toast";

const GeneralAccessManagement = ({
  isAllowedToRead,
  allowedManualPunch,
  allowedMerge,
  AttendanceViewManagement,
}) => {
  const [showDialog, setShowDialog] = useState(false);

  // Mark Attendance
  const [markAttendance] = useMarkAttendancesMutation();

  // Update sheet mutation
  const [updateAttendanceSheet] = useUpdateAttendanceSheetMutation();
  const mergeAttendanceData = async ({ selectedMonthYear, refetchAttendances }) => {
    try {
      await updateAttendanceSheet(selectedMonthYear).unwrap();
      refetchAttendances();
      showSuccessToast("Sheet updated successfully");
    } catch (err) {
      // Error toast is automatically shown by baseQuery
    }
  };

  const toggleDialog = () => {
    setShowDialog(!showDialog);
  };

  const handleConfirm = (props) => {
    mergeAttendanceData(props);
    setShowDialog(false);
  };

  return (
    <>
      {allowedManualPunch && (
        <ManualAttendance markAttendance={markAttendance} />
      )}
      {isAllowedToRead && (
        <AttendanceViewManagement
          allowedMerge={allowedMerge}
          showDialog={showDialog}
          handleConfirm={handleConfirm}
          toggleDialog={toggleDialog}
        />
      )}
    </>
  );
};

export default GeneralAccessManagement;
